import { render, staticRenderFns } from "./ExpulsionOrderNew.vue?vue&type=template&id=8cebbd46&"
import script from "./ExpulsionOrderNew.vue?vue&type=script&lang=ts&"
export * from "./ExpulsionOrderNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports